const endorsementGrpAppData = {
    endorsement:{
        endorsementType: {
            value: '',
            errorText: '',
            errorMessage: 'Endorsement type is required',
            stepsMandatory: true
        },
        reasonForInitiatingThisAction: {
            value: '',
            errorText: '',
            errorMessage: '',
            errorMessage: 'Reason for initiating action is required',
            skip: true
        },
        endorsementEffectiveDate: {
            value: '',
            errorText: '',
            errorMessage: 'Endorsement Effective Date is required',
            stepsMandatory: true
        },
    },
    nonNilCorrCustomerDetail:{
        gender:{
            value: '',
            oldValue:'',
            endorsementCode:'E003',
            errorText: '',
            errorMessage: 'Gender is required',
            skip: true
        },
        title: {
            value: '',
            oldValue:'',
            errorText: '',
            errorMessage: 'Title is required',
            endorsementCode: 'E003',
            stepsMandatory : true
        },
        dob:{
            value: '',
            oldValue:'',
            endorsementCode:'E003',
            errorText: '',
            errorMessage: 'DOB is required',
            skip: true  
        },
        mailingPincode:{
            value: '',
            oldValue:'',
            validation: ['minLength', 'onlyNumber'],
            minLength: 6,
            endorsementCode:'E005',
            errorText: '',
            errorMessage: 'Mailing Pincode is required',
            errorMessageMinLength: 'Valid Pincode is required',  
            stepsMandatory: true
        },
        state:{
            value: '',
            oldValue: '',
            errorText: '',
            endorsementCode:'E005',
            errorMessage: 'State is required',
            errorMessageMinLength: 'Valid State is required',  
            stepsMandatory: true
        },
        area:{
            value: '',
            oldValue: '',
            errorText: '',
            endorsementCode:'E005',
            errorMessage: 'Area is required',
            errorMessageMinLength: 'Valid Area is required',  
            stepsMandatory: true
        },
        city:{
            value: '',
            oldValue: '',
            errorText: '',
            endorsementCode:'E005',
            errorMessage: 'City is required',
            errorMessageMinLength: 'Valid City is required',  
            stepsMandatory: true
        },
        aadharCardNumber:{
            value: '',
            validation: ['minLength'],
            minLength: 12,
            oldValue:'',
            endorsementCode:'E007',
            aadhaarValidation : true,
            errorMessageMinLength: 'Valid Aadhaar No is required',
            errorText: '',
            skip: true
        },
        gstNumber:{
            value: '',
            validation: ['GSTNO'],
            oldValue:'',
            endorsementCode:'E008',
            errorText: '',
            errorMessageGst: 'Valid GST NO is required',
            skip: true
        },
        panNumber:{
            value: '',
            oldValue:'',
            endorsementCode:'E006',
            validation: ['panNumber'],
            errorText: '',
            maxLength: '10',
            errorMessagePanNumber:'Valid PAN Number is required',
            skip: true
        },
        // partyType:{
        //     value: '',
        //     oldValue:'',
        //     endorsementCode:'E001',
        //     errorText: '',
        //     errorMessage: 'Party Type is required',
        //     stepsMandatory: true
        // },
        // cpaApplicability:{
        //     value: '',
        //     oldValue:'',
        //     endorsementCode:'E001',
        //     errorText: '',
        //     errorMessage: 'Compulsory PA Applicability is required',
        //     stepsMandatory: true
        // },
        // cpaDuration:{
        //     value:'',
        //     oldValue:'',
        //     errorText:'',
        //     errorMessage:'CPA Period is required',
        //     endorsementCode:'E001',
        //     skip: true
        // },
        // exemptionReason:{
        //     value: '',
        //     oldValue:'',
        //     endorsementCode:'E001',
        //     errorText: '',
        //     errorMessage: 'Exemption Reason is required',
        //     stepsMandatory: true
        // },
        // paPolicyNumber:{
        //     value: '',
        //     oldValue:'',
        //     validation: ['onlyNumber'],
        //     endorsementCode:'E001',
        //     errorText: '',
        //     errorMessage: 'Policy Number is required',
        //     errorMessageMinLength: 'Valid Policy Number is required', 
        //     skip: true
        // },
        // paInsurerName:{
        //     value: '',
        //     oldValue:'',
        //     validation: ['onlyCharSpace'],
        //     endorsementCode:'E001',
        //     errorText: '',
        //     errorMessageOnlyCharSpace: 'Valid Insurer Name is required',
        //     skip: true
        // },
        // paPolicyInceptionDate:{
        //     value: '',
        //     oldValue:'',
        //     endorsementCode:'E001',
        //     errorText: '',
        //     errorMessage: 'Policy Inception Date is required',
        //     skip: true
        // },
        // paPolicyExpiryDate:{
        //     value: '',
        //     oldValue:'',
        //     endorsementCode:'E001',
        //     errorText: '',
        //     errorMessage: 'Policy Expiry Date is required',
        //     skip: true
        // },
        // paNomineeName:{
        //     value: '',
        //     oldValue:'',
        //     validation: ['onlyCharSpace'],
        //     endorsementCode:'E001',
        //     errorText: '',
        //     errorMessageOnlyCharSpace: 'Valid PA Nominee Name is required',
        //     skip: true
        // },
        // paNomineeRelation:{
        //     value: '',
        //     oldValue:'',
        //     endorsementCode:'E001',
        //     errorText: '',
        //     skip: true
        // },
        // nomineeDob:{
        //     value: '',
        //     oldValue:'',
        //     endorsementCode:'E001',
        //     errorText: '',
        //     skip: true
        // },
        // paNomineeAllocationPercentage:{
        //     value: '100',
        //     oldValue:'100',
        //     validation:['onlyNumber', 'allocPercentage'],
        //     endorsementCode:'E001',
        //     errorText: '',
        //     errorMessageMinLength: 'Valid PA Nominee Allocation (%) is required',
        //     errorMessageAllocPercentage: 'Allocation Percentage should be between 1 - 100',
        //     skip: true
        // }
    },
    changeInCPA:{
        cpaApplicability:{
            value:'',
            oldValue:'',
            errorText:'',
            errorMessage:'CPA Cover Applicability is required',
            endorsementCode:'E030',
            stepsMandatory: true
        },
        exemptionReason:{
            value: '',
            oldValue:'',
            endorsementCode:'E030',
            errorText: '',
            errorMessage: 'CPA Exemption Reason is required',
            stepsMandatory: true
        },
        paInsurerName:{
            value: '',
            oldValue:'',
            // validation:['onlyCharSpace'],
            endorsementCode:'E030',
            errorText: '',
            errorMessage: 'PA Insurer Name is required',
            skip: true
        },
        paPolicyNumber:{
            value: '',
            oldValue:'',
            endorsementCode:'E030',
            errorText: '',
            errorMessage: 'PA Policy Number is required',
            errorMessageMinLength: 'Valid PA Policy Number is required', 
            skip: true
        },
        paPolicyInceptionDate:{
            value: '',
            oldValue:'',
            endorsementCode:'E030',
            errorText: '',
            errorMessage: 'PA Policy Inception Date is required',
            skip: true
        },
        paPolicyExpiryDate:{
            value: '',
            oldValue:'',
            endorsementCode:'E030',
            errorText: '',
            errorMessage: 'PA Policy Expiry Date is required',
            skip: true
        }
    },
    correctionOfPrevPolicyDetails:{
        previousPolicyNumber:{
            value: '',
            oldValue:'',
            validation: ['alphaNumeric'],
            endorsementCode:'E011',
            errorText: '',
            errorMessage: 'Previous Policy Number is required',
            errorMessageMinLength: 'Valid PA Policy Number is required',
            stepsMandatory: true
        },
        previousInsuranceCompany:{
            value: '',
            oldValue:'',
            endorsementCode:'E011',
            errorText: '',
            errorMessage: 'Previous Insurance Company Name is required',
            stepsMandatory: true
        },
        branchAddress:{
            value: '',
            oldValue:'',
            endorsementCode:'E011',
            errorText: '',
            skip : true
        },
    },
    correctionInNCB:{
        ncbApplicable:{
            value: '',
            oldValue:'',
            endorsementCode:'E015',
            skip:true
        },
        ncbTakenFrom:{
            value: '',
            oldValue:'',
            endorsementCode:'E015',
            errorText: '',
            errorMessage: 'NCB Taken from is required',
        },
        currentYearNcb:{
            value: '',
            oldValue:'',
            endorsementCode:'E015',
            errorText: '',
            errorMessage: 'Applicable NCB % is required',
        },
        ncbRecoveryOption:{
            value: '',
            oldValue:'',
            ncbRecoveryArr: [],
            endorsementCode:'E015',
            errorText: '',
            errorMessage: 'NCB Recovery option is required',
        },
        previousPolicyNcb:{
            value: '',
            oldValue:'',
            endorsementCode:'E015',
            errorText: '',
            errorMessage: 'Previous Policy NCB % is required',
        }
    },
    ncbRecovery:{   
        ncbApplicable:{
            value: '',
            oldValue:'',
            endorsementCode:'E016',
            skip:true
        },
        ncbTakenFrom:{
            value: '',
            oldValue:'',
            endorsementCode:'E016',
            errorText: '',
            errorMessage: 'NCB Taken from is required',
        },
        currentYearNcb:{
            value: '',
            oldValue:'',
            endorsementCode:'E016',
            errorText: '',
            errorMessage: 'Applicable NCB % is required',
        },
        previousPolicyNcb:{
            value: '',
            oldValue:'',
            endorsementCode:'E016',
            errorText: '',
            errorMessage: 'Previous Policy NCB % is required',
            stepsMandatory:true
        }
    },
    changeInExcess:{
        excessType:{
            value:'',
            oldValue:'',
            errorText:'',
            errorMessage:'Excess Type is required',
            endorsementCode:'E022',
            stepsMandatory: true
        },
        additionalExcessAmount:{
            value:'',
            oldValue:'',
            errorText:'',
            errorMessage:'Additional Excess Amount is required',
            endorsementCode:'E022',
            stepsMandatory: true
        }
    },
    changeInVehicleIdv:{
        vehicleIDV:{
            value:'',
            oldValue:'',
            validation: ['onlyNumber'],
            errorText:'',
            errorMessage:'Vehicle IDV is required',
            errorMessageMinLength: 'Valid Battery IDV is required',
            endorsementCode:'E025#E026',
            stepsMandatory: true
        }
    },
    nomineeDetailsCorrection:{
        paNomineeName:{
            value:'',
            oldValue:'',
            validation: ['onlyCharSpace'],
            errorText:'',
            errorMessageOnlyCharSpace: 'Valid Insurer Name is required',
            endorsementCode:'E027',
            skip: true
        },
        paNomineeRelation:{
            value:'',
            oldValue:'',
            errorText:'',
            endorsementCode:'E027',
            skip: true
        },
        nomineeDob:{
            value:'',
            oldValue:'',
            errorText:'',
            endorsementCode:'E027',
            skip: true
        },
        paNomineeAllocationPercentage:{
            value:'100',
            oldValue:'100',
            validation:['onlyNumber', 'allocPercentage'],
            errorText:'',
            errorMessageMinLength: 'Please enter valid PA Nominee Allocation (%)',
            errorMessageAllocPercentage: 'Allocation Percentage should be between 1 - 100',
            endorsementCode:'E027',
            skip: true
        }
    },
    additionOfCpa:{
        cpaApplicability:{
            value:'',
            oldValue:'',
            errorText:'',
            errorMessage:'CPA Cover Applicability is required',
            endorsementCode:'E028',
            stepsMandatory: true
        },
        cpaDuration:{
            value:'',
            oldValue:'',
            errorText:'',
            errorMessage:'CPA Period is required',
            endorsementCode:'E028',
            stepsMandatory: true
        },
        paNomineeName:{
            value:'',
            oldValue:'',
            validation: ['onlyCharSpace'],
            errorText:'',
            errorMessageOnlyCharSpace: 'Valid PA Nominee Name is required',
            endorsementCode:'E028',
            skip: true
        },
        paNomineeRelation:{
            value:'',
            oldValue:'',
            errorText:'',
            endorsementCode:'E028',
            skip: true
        },
        nomineeDob:{
            value:'',
            oldValue:'',
            errorText:'',
            endorsementCode:'E028',
            skip: true
        },
        paNomineeAllocationPercentage:{
            value:'100',
            oldValue:'100',
            validation:['onlyNumber', 'allocPercentage'],
            errorText:'',
            errorMessageMinLength: 'Valid PA Nominee Allocation (%) is required',
            errorMessageAllocPercentage: 'Allocation Percentage should be between 1 - 100',
            endorsementCode:'E028',
            skip: true
        }
    },
    deletionOfCpa:{
        cpaApplicability:{
            value:'',
            oldValue:'',
            errorText:'',
            errorMessage:'CPA Cover Applicability is required',
            endorsementCode:'E029',
            stepsMandatory: true
        },
        exemptionReason:{
            value:'',
            oldValue:'',
            errorText:'',
            errorMessage:'Exemption Reason is required',
            endorsementCode:'E029',
            stepsMandatory: true
        },
        cpaDuration:{
            value:'',
            oldValue:'',
            errorText:'',
            errorMessage:'CPA Period is required',
            endorsementCode:'E029',
            skip: true
        },
        paPolicyNumber:{
            value:'',
            oldValue:'',
            errorText:'',
            errorMessage:'PA Policy Number is required',
            errorMessageMinLength: 'Valid PA Policy Number is required',
            endorsementCode:'E029',
            skip: true
        },
        paInsurerName:{
            value:'',
            oldValue:'',
            // validation: ['onlyCharSpace'],
            errorText:'',
            errorMessage: 'Valid PA Insurer Name is required',
            endorsementCode:'E029',
            skip: true
        },
        paPolicyInceptionDate:{
            value:'',
            oldValue:'',
            errorText:'',
            errorMessage:'PA Policy Inception Date is required',
            endorsementCode:'E029',
            skip: true
        },
        paPolicyExpiryDate:{
            value:'',
            oldValue:'',
            errorText:'',
            errorMessage:'PA Policy Expiry Date is required',
            endorsementCode:'E029',
            skip: true
        }
    },
    trailerDetails:{
        trailerTowedBy:{
            value:'',
            skip: true,
        },
        trailers: []
    },
    additionOfImt:{
        searchToAddImts:{
            value:'',
            oldValue:'',
            errorText:'',
            errorMessage:'',
            endorsementCode:''
        },
        employedAsDrivers:{
            value:'',
            oldValue:'',
            errorText:'',
            errorMessage:'Employed as drivers* is required',
            endorsementCode:''
        },
        hypothecationInstitute: {
            value: '',
            validation: ['alphaNumericSpace'],
            minLength: 30,
            errorText: '',
            endorsementCode:'E035',
            errorMessage: 'Hypothecation Institute is required',
            errorMessageAlphaNumericSpace: 'Valid Hypothecation Institute is required'
        },
        hypothecationType:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Hypothecation Type is required',
            // errorTypeMandatoryCheck : 'Hypothecation Type is required if Hypothecation Institution Name is selected',
            endorsementCode: 'E035',
        },
    },
    deletionOfImt:{
        employedAsDrivers:{
            value:'',
            oldValue:'',
            errorText:'',
            errorMessage:'Employed as drivers is required',
            endorsementCode:''
        }
    },
    transferOfOwnership:{
        partyId:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Party Code is required',
            endorsementCode: 'E010',
            skip: true,
            visibleInSearchParty: true
        },
        partyType:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Party Type is required',
            endorsementCode: 'E010',
            stepsMandatory: true,
            visibleInSearchParty: true
        },
        title: {
            value: '',
            oldValue:'',
            errorText: '',
            errorMessage: 'Title is required',
            endorsementCode: 'E010',
            stepsMandatory : true
        },
        firstName:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'First Name is required',
            endorsementCode: 'E010',
            stepsMandatory : true
        },
        middleName:{
            value:'',
            oldValue:'',
            errorText: '',
            endorsementCode: 'E010',
            skip : true
        },
        lastName:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Last Name is required',
            endorsementCode: 'E010',
            stepsMandatory : true
        },
        organizationName: {
            value: '',
            oldValue:'',
            errorText: '',
            stepsMandatory: true,
            endorsementCode: 'E010',
            isUnderOrganizationFlag: true,
            validation: ['alphaNumericSpace'],
            errorMessage: 'Organization Name is required',
            errorMessageAlphaNumericSpace: 'Valid Organization Name is required',
        },
        registeredBusiness: {
            value: false,
            oldValue:'',
            skip: true,
            endorsementCode: 'E010',
        },
        businessRegistrationNumber: {
            value: '',
            oldValue:'',
            errorText: '',
            validation: ['onlyNumber'],
            skip: true,
            endorsementCode: 'E010',
            errorMessage: 'Business Registration Number/ Trust Number is required',
            errorMessageMinLength:'Valid Business Registration Number is required'  
        },
        businessRegistrationDate: {
            value: '',
            oldValue:'',
            errorText: '',
            endorsementCode: 'E010',
            skip: true,
            errorMessage: 'Date of Registration is required',
        },
        gstNumber : {
            value : '',
            oldValue:'',
            errorText : '',
            endorsementCode: 'E010',
            errorMessage : 'GST Number is required',
            validation : ['GSTNO'],
            errorMessageGst:'Valid GST Number is required',
            skip : true
        },
        gstRegnStatus : {
            value : '',
            oldValue:'',
            skip : true,
            endorsementCode: 'E010',
        },
        gstIssuanceDate : {
            value : '',
            oldValue:'',
            errorText : '',
            endorsementCode: 'E010',
            errorMessage : 'GST Issuance Date is required',
            skip : true
        },
        hidePermanentAddress: true,
        // addressCheck: false,
        correspondenceAddress : {
            addressLine1: {
                value: '',
                oldValue:'',
                endorsementCode: 'E010',
                validation: ['addressOnly'],
                minLength: 200,
                errorText: '',
                errorMessage: 'Address is required',
                errorMessageAddressOnly: 'Valid Address is required',
                stepsMandatory : true
            },
            pincode: {
                value: '',
                oldValue:'',
                endorsementCode: 'E010',
                validation: ['minLength', 'onlyNumber'],
                minLength: 6,
                errorText: '',
                errorMessage: 'Pincode is required',
                errorMessageMinLength: 'Valid Pincode is required',
                stepsMandatory : true
            },
            city: {
                value: '',
                oldValue:'',
                endorsementCode: 'E010',
                minLength: 50,
                errorText: '',
                errorMessage: 'City is required',
                stepsMandatory : true
            },
            area: {
                value: '',
                oldValue:'',
                endorsementCode: 'E010',
                minLength: 80,
                errorText: '',
                errorMessage: 'Area is required',
                stepsMandatory : true
            },
            state: {
                value: '',
                oldValue:'',
                endorsementCode: 'E010',
                minLength: 50,
                errorText: '',
                errorMessage: 'State is required',
                stepsMandatory : true
            },
            mobileNo:{
                value:'',
                oldValue:'',
                validation: ['indianMobileNumber'],
                errorText: '',
                errorMessage: 'Either Mobile Number or Email Id is required',
                errorMessageMinLength: 'Valid Mobile Number is required',
                endorsementCode: 'E010',
                stepsMandatory : true
            },
            emailId :{
                value:'',
                oldValue:'',
                validation: ['email'],
                errorText: '',
                errorMessage: 'Either Mobile Number or Email Id is required',
                errorMessageEmail: 'Valid Email Id is required',
                endorsementCode: 'E010',
                stepsMandatory : true
            },
            panNumber:{
                value: '',
                oldValue:'',
                endorsementCode:'E010',
                validation: ['panNumber'],
                errorText: '',
                maxLength: '10',
                errorMessagePanNumber:'Valid PAN Number is required',
                skip: true
            },
        },
        permanentAddress: {
            addressLine1: {
                value: '',
                oldValue:'',
                endorsementCode: 'E010',
                validation: ['addressOnly'],
                minLength: 200,
                errorText: '',
                errorMessage: 'Address is required',
                errorMessageAddressOnly: 'Valid Address is required',
                stepsMandatory : true
            },
            pincode: {
                value: '',
                oldValue:'',
                endorsementCode: 'E010',
                validation: ['minLength', 'onlyNumber'],
                minLength: 6,
                errorText: '',
                errorMessage: 'Pincode is required',
                errorMessageMinLength: 'Valid Pincode is required',
                stepsMandatory : true
            },
            city: {
                value: '',
                oldValue:'',
                endorsementCode: 'E010',
                minLength: 50,
                errorText: '',
                errorMessage: 'City is required',
                stepsMandatory : true
            },
            area: {
                value: '',
                oldValue:'',
                endorsementCode: 'E010',
                minLength: 80,
                errorText: '',
                errorMessage: 'Area is required',
                stepsMandatory : true
            },
            state: {
                value: '',
                oldValue:'',
                endorsementCode: 'E010',
                minLength: 50,
                errorText: '',
                errorMessage: 'State is required',
                stepsMandatory : true
            }
        },
        hypothecationApplicable: {
            value: '',
            oldValue:'',
            endorsementCode: 'E010',
            visibleInSearchParty: true,
            skip: true
        },
        hypothecationType:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Hypothecation Type is required',
            errorTypeMandatoryCheck : 'Hypothecation Type is required if Hypothecation Institution Name is selected',
            endorsementCode: 'E010',
            visibleInSearchParty: true,
            ownerDetailsVisibility: true,
        },
        hypothecationInstitute:{
            value:'',
            oldValue:'',
            errorText: '',
            validation: ['alphaNumericSpace'],
            minLength: 30,
            errorMessageAlphaNumericSpace: 'Valid Hypothecation Institute is required',
            errorMessage: 'Hypothecation Institute is required',
            endorsementCode: 'E010',
            visibleInSearchParty: true,
            ownerDetailsVisibility: true,
        },
        hypothicationRemarks:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: '',
            endorsementCode: 'E010',
            visibleInSearchParty: true,
            skip: true
        },
        vehicleTransferredToWhom: {
            value: '',
            oldValue:'',
            errorText: '',
            errorMessage: 'Vehicle Transferred to whom is required',
            endorsementCode: '',
            visibleInSearchParty: true,
            ownerDetailsVisibility: true
        },
        ncbApplicable:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: '',
            endorsementCode: 'E009',
            visibleInSearchParty: true,
            skip:true
        },
        ncbTakenFrom:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'NCB Taken from is required',
            endorsementCode: 'E009',
            visibleInSearchParty: true,
            ownerDetailsVisibility: true
        },
        currentYearNcb:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Applicable NCB % is required',
            endorsementCode: 'E009',
            visibleInSearchParty: true,
            ownerDetailsVisibility: true
        },
        ncbPreviousPolicyNumber:{
            value: '',
            oldValue:'',
            validation: ['alphaNumeric'],
            endorsementCode:'',
            errorText: '',
            visibleInSearchParty: true,
            errorMessage: 'Previous Policy Number as per NCB Retention is required',
            errorMessageMinLength: 'Valid PA Policy Number is required',
            ownerDetailsVisibility: true
        },
        ncbEngineNumber: {
            value:'',
            oldValue:'',
            validation: ['alphaNumeric'],
            minLength: 6,
            endorsementCode:'',
            errorText: '',
            visibleInSearchParty: true,
            errorMessage: 'Engine Number as per NCB Retention is required',
            errorMessageAlphaNumeric: 'Valid Engine Number as per NCB Retention is required',
            errorMessageBlocked: 'Engine Number is blocked',
            ownerDetailsVisibility: true
        },
        ncbChassisNo: {
            value:'',
            oldValue:'',
            errorMessage: 'Chassis Number as per NCB Retention is required',
            minLength: 17,
            endorsementCode:'',
            errorText: '',
            visibleInSearchParty: true,
            ownerDetailsVisibility: true,
            chassisMandatory : true,
            errorMessageAlphaNumeric: 'Valid Chassis Number as per NCB Retention is required',
            validation: ['alphaNumeric'],
        },
        ncbRegistrationNumber: {
            values: ['','','',''],
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Registration Number as per NCB Retention is required',
            errorMessageAlphaNumeric: 'Registration number is not as per format.Kindly enter correct registration number',
            errorMessageValid: "Registration number is not as per format.Kindly enter correct registration number",
            errorMessageBlocked: "Registration Number is blocked",
            visibleInSearchParty: true,
            ownerDetailsVisibility: true,
            // minLength: 15,
            validation: [] ,//to be added later
            endorsementCode: 'E031'
        },
        ncbRetentionLetterEffectiveDate: {
            value: '',
            oldValue:'',
            errorText: '',
            endorsementCode:'',
            visibleInSearchParty: true,
            ownerDetailsVisibility: true,
            errorMessage: 'Retention Letter Effective Date as per NCB Retention is required',
        },
        cpaApplicability:{
            value: '',
            oldValue:'',
            endorsementCode:'E010',
            errorText: '',
            errorMessage: 'Compulsory PA Applicability is required',
            stepsMandatory: true,
            visibleInSearchParty: true,
            ownerDetailsVisibility: true
        },
        exemptionReason:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Exemption Reason is required',
            endorsementCode: 'E010',
            visibleInSearchParty: true,
            ownerDetailsVisibility: true
        },
        cpaDuration:{
            value:'',
            oldValue:'',
            errorText:'',
            errorMessage:'CPA Period is required',
            endorsementCode:'E010',
            stepsMandatory: true,
            visibleInSearchParty: true,
            ownerDetailsVisibility: true
        },
        paNomineeName:{
            value:'',
            oldValue:'',
            errorText:'',
            endorsementCode:'E010',
            visibleInSearchParty: true,
            skip: true
        },
        paNomineeRelation:{
            value:'',
            oldValue:'',
            errorText:'',
            endorsementCode:'E010',
            visibleInSearchParty: true,
            skip: true
        },
        paNomineeAllocationPercentage:{
            value:'100',
            oldValue:'100',
            errorText:'',
            validation:['onlyNumber', 'allocPercentage'],
            endorsementCode:'E010',
            errorMessageAllocPercentage: 'Allocation Percentage should be between 1 - 100',
            visibleInSearchParty: true,
            skip: true
        },
        paPolicyNumber:{
            value: '',
            oldValue:'',
            endorsementCode:'E010',
            errorText: '',
            errorMessage: 'PA Policy Number is required',
            errorMessageMinLength: 'Valid PA Policy Number is required', 
            visibleInSearchParty: true,
            skip: true
        },
        paInsurerName:{
            value: '',
            oldValue:'',
            // validation: ['onlyCharSpace'],
            endorsementCode:'E010',
            errorText: '',
            errorMessage: 'PA Insurer Name is required',
            // errorMessageOnlyCharSpace: 'Valid PA Insurer Name is required',
            visibleInSearchParty: true,
            skip: true
        },
        paPolicyInceptionDate:{
            value: '',
            oldValue:'',
            endorsementCode:'E010',
            errorText: '',
            errorMessage: 'PA Policy Inception Date is required',
            visibleInSearchParty: true,
            skip: true
        },
        paPolicyExpiryDate:{
            value: '',
            oldValue:'',
            endorsementCode:'E010',
            errorText: '',
            errorMessage: 'PA Policy Expiry Date is required',
            visibleInSearchParty: true,
            skip: true
        }
    },
    preInspectionDetails:{
        preInspectionNo: {
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Pre inspection Number is required',
            endorsementCode: '',
            stepsMandatory : true
        },
        inspectionDate:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Inspection Date is required',
            endorsementCode: '',
            stepsMandatory : true
        },
        inspectionTime:{
            value:{ hh : null, mm : null, A :null },
            oldValue:'',
            errorText: '',
            errorMessage: 'Time is required',
            endorsementCode: '',
            stepsMandatory : true
        },
        preInspectionModal:{
            typeOfInspection: 'sendInspectionLinktoCustomer',
            type:{
                value:'',
                oldValue:'',
                errorText: '',
                errorMessage: 'PreInspection Type is required',
                endorsementCode: '',
                stepsMandatory : true
            },
            firstName:{
                value:'',
                oldValue:'',
                errorText: '',
                errorMessage: 'First Name is required',
                endorsementCode: '',
                stepsMandatory : true 
            },
            lastName:{
                value:'',
                oldValue:'',
                errorText: '',
                errorMessage: 'Last Name is required',
                endorsementCode: '',
                stepsMandatory : true 
            },
            organizationName:{
                value: '',
                oldValue:'',
                errorText: '',
                stepsMandatory: false,
                endorsementCode: 'E010',
                isUnderOrganizationFlag: true,
                validation: ['alphaNumericSpace'],
                errorMessage: 'Organization Name is required',
                errorMessageAlphaNumericSpace: 'Valid Organization Name is required',
            },
            address:{
                value:'',
                oldValue:'',
                errorText: '',
                errorMessage: 'PreInspection Address is required',
                endorsementCode: '',
                stepsMandatory : true                
            },
            landmark:{
                value:'',
                oldValue:'',
                errorText: '',
                endorsementCode: '', 
                minLength: 80,
                validation:['alphanumeric'],
                errorMessage: 'PreInspection Landmark is required',
                stepsMandatory:true            
            },
            pinCode:{
                value:'',
                oldValue:'',
                errorText: '',
                errorMessage: 'PreInspection Pincode is required',
                endorsementCode: '',
                validation: ['alphanumeric','minLength', 'onlyNumber'],
                minLength: 6,
                errorMessageRecheck : '',
                errorMessageMinLength: 'Valid Pincode is required',
                errorMessageAlphaNumeric: 'Valid Pincode is required',
                stepsMandatory:true 
            },
            city:{
                value:'',
                oldValue:'',
                errorText: '',
                minLength: 60,
                errorMessage: 'PreInspection City is required',
                endorsementCode: '',
                stepsMandatory : true  
            },
            state:{
                value:'',
                oldValue:'',
                errorText: '',
                minLength: 60,
                errorMessage: 'PreInspection State is required',
                endorsementCode: '',
                stepsMandatory : true  
            },
            area:{
                value:[],
                oldValue:'',
                errorText: '',
                errorMessage: 'Area is required',
                endorsementCode: '',
                stepsMandatory : true 
            },
            mobileNumber:{
                value:'',
                oldValue:'',
                errorText: '',
                endorsementCode: '',
                errorMessage: 'Mobile Number is required',
                validation: ['indianMobileNumber'],
                errorMessageMinLength: 'Valid Mobile Number is required',
                stepsMandatory : true
            },
            inspectionPlanDate:{
                value:'',
                oldValue:'',
                errorText: '',
                errorMessage: 'Inspection PlanDate is required',
                endorsementCode: '',
                stepsMandatory : true 
            },
            remarks:{
                value:'',
                oldValue:'',
                errorText: '',
                errorMessage: 'Remarks is required',
                endorsementCode: '',
                stepsMandatory : true 
            }
        }
    },
    nilCorrCustomerDetail:{
        firstName:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'First Name is required',
            endorsementCode: 'E002',
            stepsMandatory : true
        },
        middleName:{
            value:'',
            oldValue:'',
            errorText: '',
            endorsementCode: 'E002',
            skip : true
        },
        lastName:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Last Name is required',
            endorsementCode: 'E002',
            stepsMandatory : true
        },
        businessName:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Business Name is required',
            endorsementCode: 'E002',
            skip : true
        },
        mobileNo:{
            value:'',
            oldValue:'',
            validation: ['indianMobileNumber'],
            errorText: '',
            errorMessage: 'Either Mobile Number or Email Id is required',
            errorMessageMinLength: 'Valid Mobile Number is required',
            endorsementCode: 'E004',
            stepsMandatory : true
        },
        emailId :{
            value:'',
            oldValue:'',
            validation: ['email'],
            errorText: '',
            errorMessage: 'Either Mobile Number or Email Id is required',
            errorMessageEmail: 'Valid Email Id is required',
            endorsementCode: 'E004',
            stepsMandatory : true
        },
        secondaryMobileNo:{
            value:'',
            oldValue:'',
            validation: ['indianMobileNumber'],
            errorText: '',
            errorMessageMinLength: 'Valid Mobile Number is required',
            endorsementCode: 'E004',
            skip : true
        },
        secondaryEmailId:{
            value:'',
            oldValue:'',
            validation: ['email'],
            errorText: '',
            errorMessageEmail: 'Valid Email Id is required',
            endorsementCode: 'E004',
            skip : true
        },
        // insuredAddress:{
        //     value:'',
        //     oldValue:'',
        //     errorText: '',
        //     endorsementCode: 'E004',
        //     skip : true
        // },
        hidePermanentAddress: true,
        // addressCheck: false,
        correspondenceAddress : {
            addressLine1: {
                value: '',
                oldValue:'',
                endorsementCode: 'E004',
                validation: ['addressOnly'],
                minLength: 200,
                errorText: '',
                errorMessage: 'Address is required',
                errorMessageAddressOnly: 'Valid Address is required',
                stepsMandatory : true
            },
            pincode: {
                value: '',
                oldValue:'',
                endorsementCode: 'E004',
                validation: ['minLength', 'onlyNumber'],
                minLength: 6,
                errorText: '',
                errorMessage: 'Pincode is required',
                errorMessageMinLength: 'Valid Pincode is required',
                stepsMandatory : true
            },
            city: {
                value: '',
                oldValue:'',
                endorsementCode: 'E004',
                minLength: 50,
                errorText: '',
                errorMessage: 'City is required',
                stepsMandatory : true
            },
            area: {
                value: '',
                oldValue:'',
                endorsementCode: 'E004',
                minLength: 80,
                errorText: '',
                errorMessage: 'Area is required',
                stepsMandatory : true
            },
            state: {
                value: '',
                oldValue:'',
                endorsementCode: 'E004',
                minLength: 50,
                errorText: '',
                errorMessage: 'State is required',
                stepsMandatory : true
            }
        },
        permanentAddress: {
            addressLine1: {
                value: '',
                oldValue:'',
                endorsementCode: 'E004',
                validation: ['addressOnly'],
                minLength: 200,
                errorText: '',
                errorMessage: 'Address is required',
                errorMessageAddressOnly: 'Valid Address is required',
                stepsMandatory : true
            },
            pincode: {
                value: '',
                oldValue:'',
                endorsementCode: 'E004',
                validation: ['minLength', 'onlyNumber'],
                minLength: 6,
                errorText: '',
                errorMessage: 'Pincode is required',
                errorMessageMinLength: 'Valid Pincode is required',
                stepsMandatory : true
            },
            city: {
                value: '',
                oldValue:'',
                endorsementCode: 'E004',
                minLength: 50,
                errorText: '',
                errorMessage: 'City is required',
                stepsMandatory : true
            },
            area: {
                value: '',
                oldValue:'',
                endorsementCode: 'E004',
                minLength: 80,
                errorText: '',
                errorMessage: 'Area is required',
                stepsMandatory : true
            },
            state: {
                value: '',
                oldValue:'',
                endorsementCode: 'E004',
                minLength: 50,
                errorText: '',
                errorMessage: 'State is required',
                stepsMandatory : true
            }
        }
    },
    registrationNoCorrection :{
        rtaCity:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Registration Location is required',
            minLength: 50,
            endorsementCode: 'E031',
            stepsMandatory: true
        },
        registrationNumber: {
            values: ['','','',''],
            oldValue:'',
            errorText: '',
            errorMessage: 'Registration Number is required',
            errorMessageAlphaNumeric: 'Registration number is not as per format.Kindly enter correct registration number',
            errorMessageValid: "Registration number is not as per format.Kindly enter correct registration number",
            errorMessageBlocked: "Registration Number is blocked",
            stepsMandatory : true,
            // minLength: 15,
            validation: [] ,//to be added later
            endorsementCode: 'E031'
        },
        // newForRegistrationNumberForNBCases:{
        //     value:'',
        //     oldValue:'',
        //     errorText: '',
        //     errorMessage: '',
        //     endorsementCode: 'E031'
        // },
        // registrationNumberSpecifiedFormat:{
        //     value:'',
        //     oldValue:'',
        //     errorText: '',
        //     errorMessage: '',
        //     endorsementCode: 'E031'
        // },
        // rtaPincode: {
        //     value:'',
        //     oldValue:'',
        //     errorText:'',
        //     errorMessage:'Pin Code(RTA) is required',
        //     errorMessageMinLength: 'Valid Pincode is required',
        //     validation: ['minLength', 'onlyNumber'],
        //     endorsementCode:'E031',
        //     stepsMandatory: true
        // },
        // registrationAuthority: {
        //     value:'',
        //     oldValue:'',
        //     errorText:'',
        //     endorsementCode:'E031',
        //     skip: true
        // },
    },
    pinDamageDetail:{
        preInspectionNo:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Pre Inspection Number is required',
            endorsementCode: 'E034',
            stepsMandatory: true
        },
        pinDamageDetails:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Pin Damage Details is required',
            endorsementCode: 'E034', //autopopulated field
            stepsMandatory: true
        }
    },
    changeInHypothecation:{
        hypothecationApplicable: {
            value: '',
            oldValue:'',
            endorsementCode: 'E037',
            skip: true
        },
        hypothecationType:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Hypothecation Type is required',
            errorTypeMandatoryCheck : 'Hypothecation Type is required if Hypothecation Institution Name is selected',
            endorsementCode: 'E037',
            stepsMandatory: true
        },
        hypothecationInstitute:{
            value:'',
            oldValue:'',
            errorText: '',
            validation: ['alphaNumericSpace'],
            minLength: 30,
            errorMessageAlphaNumericSpace: 'Valid Hypothecation Institute is required',
            errorMessage: 'Hypothecation Institute is required',
            endorsementCode: 'E037',
            stepsMandatory: true
        },
        hypothicationRemarks:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Remarks is required',
            endorsementCode: 'E037',
            skip: true
        }
    },
    vehicleLaidUp:{
        laidUpApplied:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Laid up Applied is required',
            endorsementCode: 'E055',
            stepsMandatory: true
        },
        postLaidUpAdjustment:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Post Laid up adjustment is required',
            endorsementCode: 'E055',
            stepsMandatory: true
        },
        laidUpPeriodFrom:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Laid up Period From is required',
            endorsementCode: 'E055',
            stepsMandatory: true
        },
        laidUpPeriodTo:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Laid up Period To is required',
            endorsementCode: 'E055',
            stepsMandatory: true
        },
        laidUpStartDate:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Laid up start date is required',
            endorsementCode: 'E055',
            stepsMandatory: true
        },
        laidUpEndDate:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Laid up End date is required',
            endorsementCode: 'E055',
            stepsMandatory: true
        }
    },
    correctionInVehicleDetails: {
        manufacturingYear:{
            value:'',
            oldValue:'',
            errorText:'',
            errorMessage:'Year of Manufacturing is required',
            endorsementCode:'E013',
            stepsMandatory: true
        },
        vehicleSubType: {
            value:'',
            oldValue:'',
            errorText:'',
            minLength: 30,
            errorMessage:'Vehicle Sub Type is required',
            endorsementCode:'E013',
            stepsMandatory: true
        },
        registrationDate: {
            value:'',
            oldValue:'',
            errorText:'',
            errorMessage:'Date of Registration is required',
            endorsementCode:'E013',
            stepsMandatory: true
        },
        // rtaCity:{
        //     value:'',
        //     oldValue:'',
        //     errorText: '',
        //     errorMessage: 'Registration Location is required',
        //     minLength: 50,
        //     endorsementCode: 'E013',
        //     stepsMandatory: true
        // },
        // rtaPincode: {
        //     value:'',
        //     oldValue:'',
        //     errorText:'',
        //     errorMessage:'Pin Code(RTA) is required',
        //     errorMessageMinLength: 'Valid Pincode is required',
        //     validation: ['minLength', 'onlyNumber'],
        //     endorsementCode:'E013',
        //     skip: true
        // },
        // registrationAuthority: {
        //     value:'',
        //     oldValue:'',
        //     errorText:'',
        //     endorsementCode:'E013',
        //     skip: true
        // },
        // vehicleMake: {   //should be makeNmodel
        //     value: '',
        //     errorText: '',
        //     errorMessage: 'Make and Model is required',
        //     minLength: 30,
        //     skip : true
        // },
        // cubicCapacity: {
        //     value:'',
        //     oldValue:'',
        //     errorText:'',
        //     errorMessage:'Cubic Capacity is required',
        //     endorsementCode:'E013',
        //     skip: true
        // },
        // carryingCapacity: {
        //     value:'',
        //     oldValue:'',
        //     errorText:'',
        //     errorMessage:'Carrying Capacity is required',
        //     endorsementCode:'E013',
        //     skip: true
        // },
        vehicleGVW: {
            value:'',
            oldValue:'',
            errorText:'',
            errorMessage:'GVW is required',
            endorsementCode:'E024',
            errorMessageMinLength: 'Please enter valid GVW',
            errorMessageRange: 'GVW Range: ',
            validation: ['onlyNumber','maxValue','minValue'],
            minLength: 20,
            stepsMandatory: true
        },
        seatingCapacity: {
            value:'',
            oldValue:'',
            errorText:'',
            errorMessage:'Seating Capacity is required',
            endorsementCode:'E023',
            skip: true
        },
        // vehicleZone: {
        //     value:'',
        //     oldValue:'',
        //     errorText:'',
        //     errorMessage:'Zone is required',
        //     endorsementCode:'E014',
        //     skip: true
        // },
        engineNumber: {
            value:'',
            oldValue:'',
            validation: ['alphaNumeric'],
            minLength: 6,
            endorsementCode:'E032',
            errorText: '',
            errorMessage: 'Engine Number is required',
            errorMessageAlphaNumeric: 'Valid Engine Number is required',
            errorMessageBlocked: 'Engine Number is blocked',
            stepsMandatory : true
        },
        chassisNo: {
            value:'',
            oldValue:'',
            errorMessage: 'Chassis Number is required',
            minLength: 17,
            endorsementCode:'E033',
            stepsMandatory : true,
            errorText: '',
            chassisMandatory : true,
            errorMessageAlphaNumeric: 'Valid Chassis Number is required',
            validation: ['alphaNumeric'],
        },
        // batteryDetails:{
        batteryWithGps: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        batteryIdv: { 
            value: '0',
            errorText: '',
            oldValue:'',
            endorsementCode:'E050',
            errorMessage: 'Battery IDV is required',
            validation: ["onlyNumber"],
            errorMessageMinLength: 'Valid Battery IDV is required',
            skip : true
        },
        removableFixedBattery: {
            value: '',
            oldValue:'',
            errorText: '',
            errorMessage: 'Removable/Fixed Battery is required',
            endorsementCode:'E050',
            skip: true
        },
        batteryType: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            insideDropDown : true,
            skip: true
        },
        batteryManufacturingDate: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        batteryWarranty: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        temperatureZone: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            insideDropDown : true,
            skip: true
        },
        chargeInfraAvailableInHouseOrPublic: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            insideDropDown : true,
            skip: true
        },
        acDCCharger: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            insideDropDown : true,
            skip: true
        },
        partTypeFiberOrMetal: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        batteryMake: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        batteryPowerVOrAh: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        cells: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        batteryAge: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        batteryWeight: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        powerWeightRatio: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        speedWeightRatio: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        motorBatteryPowerRatio: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        electricMotorPowerKwhOrBhp: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        rangeInKmInSingleCharge: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        maxSpeed: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        vehicleWeightWithBattery: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        vehicleWeightWithoutBattery: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        acceleration: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        chargingHours: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        areaInfrastructure: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        newUsedBattery:{
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        useForRental: {
            value: '',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        connectedToOtherSystemsOrCentralSystem: {
            value:'',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        batteryIsLeased: {
            value:'',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        batteryLeaseDetails: {
            value:'',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        additionalBatteryChargingProtection: {
            value:'',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        powerFluctuation: {
            value:'',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        batteryClaims: {
            value:'',
            oldValue:'',
            endorsementCode:'E050',
            skip: true
        },
        noOfClaims: {
            value:'',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        claimAmount: {
            value:'',
            oldValue:'',
            errorText:'',
            endorsementCode:'E050',
            skip: true
        },
        batterySerialNumber: {
            value: '',
            oldValue:'',
            errorText: '',
            errorMessage: 'Battery Serial Number is required',
            endorsementCode:'E050',
            skip: true
        },
        tyre1SerialNo: {
            value:'',
            oldValue:'',
            endorsementCode:'E051',
            minLength: 30,
            errorText: '',
            errorMessage: 'Tyre 1 Serial Number is required',
            stepsMandatory: false,
            skip: true
        },
        tyre2SerialNo: {
            value:'',
            oldValue:'',
            minLength: 30,
            errorText: '',
            errorMessage: 'Tyre 2 Serial Number is required',
            endorsementCode:'E051',
            stepsMandatory: false,
            skip: true
        },
        tyre3SerialNo: {
            value:'',
            oldValue:'',
            minLength: 30,
            errorText: '',
            errorMessage: 'Tyre 3 Serial Number is required',
            endorsementCode:'E051',
            stepsMandatory: false,
            skip: true
        },
        tyre4SerialNo: {
            value:'',
            oldValue:'',
            minLength: 30,
            errorText: '',
            errorMessage: 'Tyre 4 Serial Number is required',
            endorsementCode:'E051',
            stepsMandatory: false,
            skip: true
        },
        tyre5SerialNo: {
            value:'',
            oldValue:'',
            minLength: 30,
            errorText: '',
            errorMessage: 'Tyre 5 Serial Number is required',
            endorsementCode:'E051',
            stepsMandatory: false,
            skip: true
        }
        // },
    },
    extensionOfODCover:{
        policyExpiryDate:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Policy Expiry Date is required',
            endorsementCode: 'E052',
            stepsMandatory: true
        },
        policyExpiryTime:{
            value:'',
            oldValue:'',
            errorText: '',
            errorMessage: 'Policy Expiry Time is required',
            endorsementCode: 'E052',
            skip: true
        },
    }  
}   

export default endorsementGrpAppData